import { makeStyles } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { useTranslation } from 'react-i18next';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import PrintIcon from '@material-ui/icons/Print';
import { toDateFormatWithoutT,fromNewDateFormatToYYYYMMDDHHmmssDash } from '../../Helpers/dateHelper';

export default function PurchaseOrderOverviewTable(props) {
    const classes = useStyles();

    const { t } = useTranslation();

    const rows = props.purchaseOrders.map(p => {

        let supplier = props.suppliers.find(x => x.ID === p.VendorID).Name
        return (
            createData(p.ExternalReference, fromNewDateFormatToYYYYMMDDHHmmssDash(new Date(p.ContractDate)), supplier, p.ID))
    }
    )

    function createData(ref, date, supplier, id) {
        return { ref, date, supplier, id };
    }

    const editContract = (id) => {
        props.openEditContractDialog()
        props.setContractIdToEdit(id)
    }

    const printContract = (id) => {

    }

    return (
        <Table className={classes.table} aria-label="customized table">
            <TableHead>
                <TableRow>
                    <TableCell className={classes.headCell} style={{ width: "15%" }}>External Reference</TableCell>
                    <TableCell className={classes.headCell} style={{ width: "15%" }}>Date</TableCell>
                    <TableCell className={classes.headCell} style={{ width: "35%" }}>Supplier</TableCell>
                    <TableCell className={classes.headCell} style={{ width: "8%" }}></TableCell>
                    <TableCell className={classes.headCell} style={{ width: "8%" }}></TableCell>

                </TableRow>
            </TableHead>
            <TableBody>
                {rows.map((row) => (
                    <TableRow key={row.id} className={classes.row}>
                        <TableCell className={classes.infoCell} style={{ width: "15%" }}>{row.ref}</TableCell>
                        <TableCell className={classes.infoCell} style={{ width: "15%" }}>{row.date}</TableCell>
                        <TableCell className={classes.infoCell} style={{ width: "35%" }}>{row.supplier}</TableCell>
                        <TableCell className={classes.infoCell} style={{ width: "8%" }}>
                            <EditIcon className={classes.editIcon} onClick={() => editContract(row.id)}></EditIcon>
                        </TableCell>
                        <TableCell className={classes.infoCell} style={{ width: "8%" }}>
                            <PrintIcon className={classes.printIcon} onClick={() => printContract(row.id)}></PrintIcon>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    )

}

const useStyles = makeStyles(() => ({
    headCell: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        padding: "0px",
        border: "none",
        height: "10px",
        lineHeight: "0px"
    },

    infoCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        padding: "5px",
        paddingLeft: "0px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        backgroundColor: "white",
        width: "30%"
    },

    table: {
        borderSpacing: "0 5px !important",
        borderCollapse: "separate !important",
        width: "100%"

    },
    editIcon: {
        cursor: "pointer",
        color: "#1976d2",
        paddingTop: "5px"
    },
    printIcon: {
        cursor: "pointer",
        color: "#1976d2",
        paddingTop: "5px"
    },
    deleteIcon: {
        cursor: "pointer",
        color: "#1976d2",
        paddingTop: "5px"
    }

}));